import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import auth from "../../../auth";
import axios from "axios";
import InputMask from 'react-input-mask';

import TableArchivos from './TableArchivos';

import { TabContent, TabPane, Nav, NavItem, NavLink, Table, Row, Button, Col, Label, Input, InputGroup, FormFeedback, Alert } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import CurrencyInput from "../../../components/ParadigmaCurrencyInput/ParadigmaCurrencyInput.js"
import AgregarCosto from "./AgregarCosto.js"
import CreateLTA from "../../clientes/Responsables/Create.js"
import DetailEmpresas from "../../clientes/Empresas/Detail.js"

import dateFunctions from '../../functions/dateFunctions';

var columnStyle = {
    minWidth: "125px",
    maxWidth: "125px"
}

var columnStyleObs = {
    minWidth: "200px",
    maxWidth: "200px"
}

var FieldStyle = {
    maxWidth: "100%"
}

var buttonStyle = {
    fontSize: "10px",
    padding: "1.5px 5px",
    marginTop: "-2px",
}

var vaMiddle = {
    verticalAlign: 'middle'
}

var TabHeaderStyle = {
    marginTop: '-15px',
    marginRight: '-15px',
    marginBottom: '0px',
    marginLeft: '-15px',
};

var TabHeaderBody = {
    marginTop: '0px',
    marginRight: '-15px',
    marginBottom: '-15px',
    marginLeft: '-15px',
};

class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            uvt_id: null,
            ott_id: null,
            solicitud_id: null,
            plan_id: null,
            condiciondepago_id: null,
            plazo_id: null,
            plazoDeEntrega_id: null,
            lae_id: null,
            empresa_id: null,
            costos: [],
            nro: 'P0000-00',
            nro: 'AA-0000',
            valorReferencia: 0,
            ivaIncluido: 2,
            precioFinal: '',
            formaDePago: '',
            validezDeOferta: '',
            observaciones: '',

            documentosFacturas: [],

            tabPresupuesto:1,
            e_valor:'0',
            e_numero:1,
            e_array: [],

            e_alert: false,
            e_msj: '',

            obsPdf: true,
            presupuestoFormal: null,
            presupuestoFormalAux: null,
            
            estado: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    resetState() {
        this.setState({
            uvt_id: null,
            ott_id: null,
            solicitud_id: null,
            plan_id: null,
            condiciondepago_id: null,
            plazo_id: null,
            plazoDeEntrega_id: null,
            lae_id: null,
            empresa_id: null,
            costos: [],
            nro: 'P0000-00',
            nro: 'AA-0000',
            valorReferencia: 0,
            ecuacion: "",
            coeficienteGC: 0,
            coeficienteUE: 0,
            ivaIncluido: 1,
            precioFinal: '',
            formaDePago: '',
            validezDeOferta: '',
            observaciones: '',

            documentosFacturas: [],

            tabPresupuesto:1,
            e_valor:'0',
            e_numero:1,
            e_array: [],

            e_alert: false,
            e_msj: '',

            obsPdf: true,
            presupuestoFormal: null,

            estado: null,
        })
    }

    setSelects(data) {
        
        if (data.allowed==true){
            this.setState({
                uvt_id: data.uvt_id,
                ott_id: data.ott_id,
                solicitud_id: data.solicitud_id,
                plan_id: data.plan_id,
                condiciondepago_id: data.condiciondepago_id,
                plazo_id: data.plazo_id,
                plazoDeEntrega_id: data.plazoDeEntrega,
                lae_id: data.lae_id,
                empresa_id: data.empresa_id,
                costos: data.costos.sort(function (a, b) { return (a.pk > b.pk) ? 1 : ((b.pk > a.pk) ? -1 : 0); }).map((data) => {
                                                                                                    data.value= (data.value % 1 == 0) ? (dateFunctions.formatCurrencySDecimales(data.value)) : (dateFunctions.formatCurrency(data.value)); 
                                                                                                    return data}),
                nro: data.nro,
                codigo: data.codigo,
                ivaIncluido: data.ivaIncluido,
                precioFinal: (data.valorfinal % 1 == 0) ? (dateFunctions.formatCurrencySDecimales(data.valorfinal)) : (dateFunctions.formatCurrency(data.valorfinal)),
                obsPdf: data.obsPdf,
                formaDePago: data.formaDePago,
                validezDeOferta: data.validezDeOferta,
                observaciones: data.observaciones,
                documentosFacturas: (data.documentos) ? (data.documentos)  : ([]),
                // presupuestoFormal: (data.presupuestoFormal) ? (data.presupuestoFormal) : (null),
                presupuestoFormalAux: (data.presupuestoFormal) ? (data.presupuestoFormal) : (null),
                e_array: (data.etapasArray) ? (data.etapasArray.map((e)=>{e.valor = (e.valor.toString()).replace('.',','); return e})) : ([]),
                estado: (data.estado) ? (data.estado) : (null),
            }, () => (data.costos.length ? this.calculateCostos() : null));
        }
    }

    getData() {
        const { postVariables, e_array } = this.state;
        const e_arrayAux = [];
        // e_arrayAux.map((e, i)=>{e.numeroEtapa = (i+1); e.valor=parseFloat(((e.valor).replace(/[.]/g,'')).replace(',','.')); return e});
        e_array.forEach((e, i)=>{
            e_arrayAux.push({numeroEtapa:(i+1), valor:parseFloat(((e.valor).replace(/[.]/g,'')).replace(',','.'))});
        })

        let data = {
            'solicitud_id': this.state.solicitud_id,
            'ott_id': this.state.ott_id,
            'uvt_id': this.state.uvt_id,
            // 'empresa_id': this.state.empresa_id,
            'lae_id': this.state.lae_id,
            'condiciondepago_id': this.state.condiciondepago_id,
            'valorfinal': parseFloat(((this.state.precioFinal).replace(/[.]/g,'')).replace(',','.')),
            'formaDePago': this.state.formaDePago,
            'validezDeOferta': this.state.validezDeOferta,
            'plazoDeEntrega': this.state.plazoDeEntrega_id,
            'observaciones': this.state.observaciones,
            // 'plan_id': this.state.plan_id,
            'ivaIncluido': this.state.ivaIncluido,
            'costos':this.state.costos.map((e) => {e.value=e.value.replace('.','').replace(',','.'); return e}),
            // 'costos': this.state.costos,
            'obsPdf': this.state.obsPdf,
            // 'documentos': this.state.documentosFacturas.map(p => p.id ? { id: p.id } : { archivo: p.archivo }),
            // 'presupuestoFormal': this.state.presupuestoFormal,
            'etapasArray': e_arrayAux, 
        };

        return data;
    }

    onValidation = () =>{
        const { precioFinal, e_array } = this.state;
        const redEtapas = (accumulator, currentValue) => accumulator + parseFloat(currentValue.valor.replace(/[.]/g, '').replace(',', '.')); //Reducer para calcular valor total de etapas

        let validate = true;
        let e_alert = false;
        let e_msj = '';

        let tabPresupuesto = this.state.tabPresupuesto;

        if(e_array.length>0){
            let numPrecioFinal = parseFloat(precioFinal.replace(/[.]/g, '').replace(',', '.'));
            let numPrecioFinalSumCuotas = parseFloat(e_array.reduce(redEtapas, 0).toFixed(2));
            if(numPrecioFinal!=numPrecioFinalSumCuotas){
                validate=false;
                e_alert=true;
                e_msj='La suma de las etapas debe ser igual al precio del presupuesto';
                tabPresupuesto=3;
            }
        }

        this.setState({
            e_alert: e_alert,
            e_msj: e_msj,
            tabPresupuesto: tabPresupuesto,
        })

        return validate;

    }

    onChangeInput(tabN, input) {
        var i = parseInt(tabN);
        var newCostos = this.state.costos;
        newCostos[i].value = (input!=null && input!='') ? input : '0';
        this.setState({ costos: newCostos }, () => this.calculateCostos());
    }

    onChangeInputObs(tabN, input) {
        var i = parseInt(tabN);
        var newCostos = this.state.costos;
        newCostos[i].obs = input.value;
        this.setState({ costos: newCostos });
    }

    UpdateCostos(costos) {
        var newCostos = [];
        for (var i = 0; i < costos.length; i++) {
            var newCosto = costos[i];
            var oldCosto = this.state.costos.filter(x => x.pk == newCosto.pk);
            newCostos.push(
                {
                    pk: newCosto.pk,
                    nombre: newCosto.nombre,
                    value: (oldCosto.length > 0 ? oldCosto[0].value : '0'),
                    obs: (oldCosto.length > 0 ? oldCosto[0].obs : ""),
                }
            );
        }

        this.setState({ costos: newCostos }, () => this.calculateCostos());
    }

    UpdateCosto(costo) {
        var newCostos = this.state.costos;
        newCostos.push({
            pk: costo.pk,
            nombre: costo.nombre,
            value: '0',
            obs: ""
        });
        newCostos = newCostos.sort(function (a, b) { return (a.pk > b.pk) ? 1 : ((b.pk > a.pk) ? -1 : 0); });
        this.setState({ costos: newCostos }, () => this.calculateCostos());
    }

    removeRow(index) {
        var costos = this.state.costos;
        var newCostos = [];
        for (var i = 0; i < costos.length; i++) {
            if (i != index)
                newCostos.push(costos[i]);
        }
        this.setState({ costos: newCostos }, () => this.calculateCostos());
    }

    addRow(id) {
        var costo = this.state.costos.filter(x => x.pk == id)[0];
        var newCostos = this.state.costos;
        newCostos.push({
            pk: id,
            nombre: costo.nombre,
            value: '0',
            obs: ""
        });
        newCostos = newCostos.sort(function (a, b) { return (a.pk > b.pk) ? 1 : ((b.pk > a.pk) ? -1 : 0); });
        this.setState({ costos: newCostos }, () => this.calculateCostos());
    }

    calculateCostos(callback) {
        const { costos, uvt_id } = this.state;
        let arr_Costos = costos.map(x => ({ pk: x.pk, value: (typeof(x.value) == 'string') ? parseFloat(((x.value).replace(/[.]/g,'')).replace(',','.')) : (x.value) }));
        let self = this;
        let url = api.proyectos.config.presupuesto.formula.calculate + uvt_id + "/" + "?costos=" + JSON.stringify(arr_Costos);
        axios.get(url, auth.header()).then((result) => {
            if (result.status == 200) {
                self.setState({ valorReferencia: result.data.valor })
                if (callback) callback(result);
            }
        });
    }

    AddEtapa = () =>{
        let e_valor = this.state.e_valor;
        var e_array = this.state.e_array;
        let e_valorFloat = parseFloat(e_valor.replace(/[.]/g, '').replace(',', '.'));

        const redEtapas = (accumulator, currentValue) => accumulator + parseFloat(currentValue.valor.replace(/[.]/g, '').replace(',', '.')); //Reducer para calcular valor total de etapas

        if(e_valorFloat<=0){
            this.setState({e_alert: true,
                            e_msj: 'Error. El valor debe ser superior a 0'});
        }else{
            if((e_array.reduce(redEtapas, 0)+e_valorFloat) > (parseFloat(this.state.precioFinal.replace(/[.]/g, '').replace(',', '.')))){
                this.setState({e_alert: true,
                                e_msj: 'Error. La suma de las etapas debe ser igual al precio establecido al presupuesto'});
            }else{
                e_array.push({valor: e_valor});
                this.setState({e_array: e_array,
                                e_valor: '0',
                                e_alert: false,
                                e_msj: ''});
            }

        }
        
    }

    removeEtapa = (i) => {
        var e_array = this.state.e_array;
        e_array.splice(i, 1);
        this.setState({e_array: e_array});
    
    }

    downloadPresupuestoFormal = () => {
        if (this.props.id && this.state.presupuestoFormalAux!=null) {
            window.open(api.proyectos.presupuesto.presupuestoformal.replace('$id_presupuesto', this.props.id()));
        }
    }

    render() {
        const { action } = this.props;
        const { precioFinal, valorReferencia, tabPresupuesto, e_array, e_valor, e_numero, e_alert, e_msj, obsPdf, documentosFacturas, presupuestoFormal, presupuestoFormalAux, estado } = this.state;

        const redEtapas = (accumulator, currentValue) => accumulator + parseFloat(currentValue.valor.replace(/[.]/g, '').replace(',', '.')); //Reducer para calcular valor total de etapas

        var costoTotal = 0;
        var atr = [];
        if (this.state.costos) {
            let lastpk = 0;
            for (var i = 0; i < this.state.costos.length; i++) {
                let rowN = i.toString();
                var row = this.state.costos[i];
                let CostoID = row.pk;
                costoTotal += (typeof(row.value) == 'string') ? (parseFloat(((row.value).replace(/[.]/g,'')).replace(',','.'))) : (parseFloat(row.value));
                atr.push(
                    <tr key={i}>
                        <td className="d-none" scope="row">
                            <Input type="number" name={"costos[" + rowN + "][id]"} className="p-0 d-none" value={row.pk} onChange={(e) => this.onChangeInput(rowN, e.target)} />
                        </td>
                        <td className={(row.pk != lastpk ? "" : "border-0")} style={(row.pk == lastpk ? vaMiddle : null)}>

                            {(row.pk != lastpk ?
                                <Button style={buttonStyle} className={"btn-round btn-small btn-default mr-1 W-25"} onClick={(e) => { e.preventDefault(); this.addRow(CostoID) }}><i className="fa fa-plus"></i></Button>
                                : "")}

                            {(row.pk != lastpk ?
                                row.nombre
                                : "")}


                            {(row.pk == lastpk ?
                                <Button style={buttonStyle} className={"btn-round btn-small btn-danger float-right mr-1 W-25"} onClick={(e) => { e.preventDefault(); this.removeRow(parseInt(rowN)) }}><i className="fa fa-times"></i></Button>
                                : "")}

                        </td>
                        <td className={(row.pk != lastpk ? "" : "border-0") + " " + "d-none d-sm-block"}>
                            <Input type="text" name={"costos[" + rowN + "][obs]"} value={row.obs} onChange={(e) => this.onChangeInputObs(rowN, e.target)} className="form-control text-left" />
                        </td>
                        <td className={(row.pk != lastpk ? "" : "border-0")}>
                            <CurrencyInput 
                                placeholder={'0'}
                                className={'W-75'}
                                selectOnFocus={true}
                                style={{textAlign: 'right' }} 
                                maskOptions={{includeThousandsSeparator: true, allowLeadingZeroes:true}}
                                value={row.value}
                                onChange={(e) => this.onChangeInput(rowN, e)}
                                />
                            <Input type="hidden" name={"costos[" + rowN + "][valor]"} value={(typeof(row.value) == 'string') ? parseFloat(((row.value).replace(/[.]/g,'')).replace(',','.')) : (row.value)} /*onChange={(e) => this.onChangeInput(rowN, e.target)} */className="form-control text-right W-75" />
                        </td>
                    </tr>
                );
                lastpk = row.pk;
            }
        }

        var subTotal = 0;

        return (
            <ParadigmaModal
                getUrl={api.proyectos.presupuesto.edit}
                postUrl={api.proyectos.presupuesto.edit}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Presupuesto ha sido editado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                notAllowedMessage={"El Presupuesto ya se encuentra cerrado."}
                title={"Editar Presupuesto"}
                buttonTitle={"Editar Presupuesto"}
                buttonIcon={"fa fa-pencil fa-lg"}
                className={"ui-modal-dialog ui-modal-editor"}
                onValidation={this.onValidation}
                saveButton={true}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onPreSubmit={() => this.getData()}
                onClose={() => this.resetState()}

                // fileUploader
            >
                <div className="ui-form">
                <Nav tabs style={TabHeaderStyle}>
                    <NavItem>
                        <NavLink className={tabPresupuesto==1 ? 'active' : ''} onClick={() => { this.setState({tabPresupuesto:1}) }}>
                            Datos
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={tabPresupuesto==2 ? 'active' : ''} onClick={() => { this.setState({tabPresupuesto:2}) }}>
                            Pago
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={tabPresupuesto==3 ? 'active' : ''} onClick={() => { this.setState({tabPresupuesto:3}) }}>
                            Etapas
                        </NavLink>
                    </NavItem>
                    {/*<NavItem>
                        <NavLink className={tabPresupuesto==4 ? 'active' : ''} onClick={() => { this.setState({tabPresupuesto:4}) }}>
                            Archivos
                        </NavLink>
                    </NavItem>*/}
                </Nav>

                <TabContent style={TabHeaderBody} activeTab={tabPresupuesto} className={"py-2"}>
                    <TabPane tabId={1} className="py-0">
                    <Input type="hidden" name="plan_id" disabled={true} />
                    <ParadigmaLabeledInput
                        disabled
                        label={"Proyecto"}
                        fieldName=""
                        labelColumns={2}
                        fieldColumns={10}
                        inputComponent={
                            <Row noGutters>
                                <Col className="col-3 col">
                                    {this.state.codigo &&
                                        <InputMask disabled={true} className="form-control" value={this.state.codigo} type="text" />
                                    }
                                </Col>
                                <Col className="col-9 col pl-5">
                                    <ParadigmaAsyncSeeker fieldName={"solicitud_id"} url={api.proyectos.solicitudes.select} value={this.state.solicitud_id} disabled={true} />
                                </Col>
                            </Row>
                        }
                    />

                    <ParadigmaLabeledInput
                        disabled
                        label={"Oficina de Transf. Técnica"}
                        fieldName=""
                        labelColumns={5}
                        fieldColumns={7}
                        inputComponent={
                            <ParadigmaAsyncSeeker fieldName={"ott_id"} url={api.proyectos.config.presupuesto.ott.select}
                                onChange={(e) => this.setState({ ott_id: e.pk })} value={this.state.ott_id} />
                        }
                    />

                    <ParadigmaLabeledInput
                        disabled
                        label={"Unidad de Vinculación"}
                        fieldName=""
                        labelColumns={5}
                        fieldColumns={7}
                        inputComponent={
                            <ParadigmaAsyncSeeker fieldName={"uvt_id"} url={api.proyectos.config.presupuesto.uvt.select}
                                onChange={(e) => this.setState({ uvt_id: e.pk })} value={this.state.uvt_id} />
                        }
                    />

                    <ParadigmaLabeledInput
                        disabled
                        label={"Empresa/Organización"}
                        fieldName=""
                        labelColumns={5}
                        fieldColumns={7}
                        inputComponent={
                            <ParadigmaAsyncSeeker Detail={DetailEmpresas} fieldName={"empresa_id"} url={api.clientes.empresas.select}
                                value={this.state.empresa_id} disabled={true} />
                        }
                    />

                    {
                        this.state.empresa_id &&
                        <ParadigmaLabeledInput
                            label={"Contacto del Cliente"}
                            fieldName=""
                            labelColumns={5}
                            fieldColumns={7}
                            inputComponent={
                                <ParadigmaAsyncSeeker Create={CreateLTA} fieldName={"lae_id"} nombreField={"fullname"}
                                    url={api.clientes.responsables.select + "?empresa_id=" + this.state.empresa_id}
                                    onChange={(e) => this.setState({ lae_id: e.pk })} value={this.state.lae_id} />
                            }
                        />
                    }

                    <ParadigmaLabeledInput
                        label={"Moneda de Pago"}
                        fieldName=""
                        labelColumns={5}
                        fieldColumns={7}
                        inputComponent={
                            <ParadigmaAsyncSeeker fieldName={"condiciondepago_id"} url={api.proyectos.config.presupuesto.condiciones.select}
                                onChange={(e) => this.setState({ condiciondepago_id: e.pk })} value={this.state.condiciondepago_id} />
                        }
                    />

                    <Row className="mt-1">
                        <Col className="col-12">
                            <Table className="table-sm ui-cost-table">
                                <thead>
                                    <tr>
                                        <th className="d-none">#</th>
                                        <th className="col-3 align-middle">Costos</th>
                                        <th className="col-6 d-none d-sm-block" style={columnStyleObs}>
                                            <div className="d-inline-block w-50 align-middle">Obs</div>
                                        </th>
                                        <th className="col-3" style={columnStyle}>
                                            <div className="d-inline-block w-50 align-middle">Valor</div>
                                            <div className="d-inline-block text-right w-50 ml-2"><AgregarCosto buttonClass={"w-100 p-1 btn-outline-light"}
                                                checked={this.state.costos} onSubmit={(costos) => this.UpdateCostos(costos)} /> </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {atr}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>

                    <ParadigmaLabeledInput disabled marginLeftAuto labelClassName="text-right" type={"number"}
                        label={"Costo del Proyecto"} fieldName="" labelColumns={8} fieldColumns={4} value={(costoTotal % 1 == 0) ? (dateFunctions.formatCurrencySDecimales(costoTotal)) : (dateFunctions.formatCurrency(costoTotal))} />

                    <ParadigmaLabeledInput disabled marginLeftAuto labelClassName="text-right" type={"number"}
                        label={"Valor de Referencia"} fieldName="" labelColumns={8} fieldColumns={4} value={(valorReferencia % 1 == 0) ? (dateFunctions.formatCurrencySDecimales(valorReferencia)) : (dateFunctions.formatCurrency(valorReferencia))} />

                    <ParadigmaLabeledInput marginLeftAuto 
                                            labelClassName="text-right" 
                                            type={"number"}
                                            label={"Precio"} 
                                            style={{ fontWeight: 800, marginRight: '-5px' }} 
                                            labelColumns={8} 
                                            fieldColumns={4} 
                                            inputComponent={
                                                <CurrencyInput 
                                                    placeholder={'0'}
                                                    className={'monto'}
                                                    selectOnFocus={true}
                                                    style={{ fontWeight: 800, textAlign: 'right' }} 
                                                    maskOptions={{includeThousandsSeparator: true, allowLeadingZeroes:true}}
                                                    value={precioFinal}
                                                    onChange={d => this.setState({precioFinal: d})}
                                                    onBlur={() => this.setState({precioFinal: (precioFinal!=null && precioFinal!='') ? (precioFinal) : ('0')})}
                                                    />
                                            }/>
                    <ParadigmaLabeledInput marginLeftAuto labelClassName="text-right" type={"hidden"}
                                            style={{ fontWeight: 800 }} fieldName="valorfinal" labelColumns={8} fieldColumns={4} value={parseFloat(((precioFinal).replace(/[.]/g,'')).replace(',','.'))}/>


                    <Row className="mt-3">
                        <input type={"hidden"} name="ivaIncluido" value={this.state.ivaIncluido} />
                        <Col className=" row justify-content-end">
                            <Label className={"mr-4"}><input type={"radio"} checked={this.state.ivaIncluido == 1} onClick={() => this.setState({ ivaIncluido: 1 })} /> +IVA</Label>
                            <Label className={"mr-4"}><input type={"radio"} checked={this.state.ivaIncluido == 2} onClick={() => this.setState({ ivaIncluido: 2 })} /> IVA incluido</Label>
                            <Label className={""}><input type={"radio"} checked={this.state.ivaIncluido == 3} onClick={() => this.setState({ ivaIncluido: 3 })} /> Exento</Label>
                        </Col>
                    </Row>
                </TabPane>

                <TabPane tabId={2} className="py-0">

                    <ParadigmaLabeledInput
                        label={"Forma de Pago"} 
                        fieldName="formaDePago"
                        type={'textarea'}
                        maxLength={1000}
                        rows={1}
                        labelColumns={3} fieldColumns={9} 
                        onChange={(e) => this.setState({ formaDePago: e.target.value })} 
                        value={this.state.formaDePago}
                    />

                    <ParadigmaLabeledInput
                        label={"Validez de Oferta"} 
                        fieldName="validezDeOferta"
                        maxLength={100}
                        labelColumns={3} fieldColumns={9} 
                        onChange={(e) => this.setState({ validezDeOferta: e.target.value })} 
                        value={this.state.validezDeOferta}
                    />

                    <ParadigmaLabeledInput
                        label={"Plazo de Entrega"}
                        type={'textarea'}
                        maxLength={1000}
                        rows={1}
                        fieldName="plazoDeEntrega"
                        labelColumns={3} fieldColumns={9}
                        onChange={(e) => this.setState({ plazoDeEntrega_id: e.target.value })} 
                        value={this.state.plazoDeEntrega_id}
                    />

                    <ParadigmaLabeledInput
                        label={"Observaciones para el presupuesto"}
                        type={"textarea"}
                        fieldName="obsPdf"
                        labelColumns={12} fieldColumns={12} 
                        onChange={(e) => this.setState({ obsPdf: e.target.value })} 
                        value={this.state.obsPdf}
                    />
                    {/* <input type={'hidden'} name="obsPdf" value={(obsPdf==true) ? ('True') : ('False')}/> */}
                    
                    <ParadigmaLabeledInput type={"textarea"}
                        label={"Observaciones internas"} 
                        fieldName="observaciones"
                        labelColumns={12} fieldColumns={12} 
                        onChange={(e) => this.setState({ observaciones: e.target.value })} 
                        value={this.state.observaciones}
                    />

                </TabPane>

                {/* Etapas */}
                <TabPane tabId={3} className="py-0">

                    <Row className="mt-1">
                        <Col className="col-2"/>
                        <Col className="col-3">
                            <Label>Etapa N°</Label>
                            <Input type="number" className="text-right" value={(e_array.length+1)} disabled></Input>
                        </Col>
                        <Col className="col-4">
                            <Label>Valor</Label>                            
                            <CurrencyInput 
                                placeholder={'0'}
                                className={'monto'}
                                selectOnFocus={true}
                                style={{ fontWeight: 800, textAlign: 'right' }} 
                                maskOptions={{includeThousandsSeparator: true, allowLeadingZeroes:true}}
                                value={e_valor}
                                onChange={d => this.setState({e_valor: d})}
                                onBlur={() => this.setState({e_valor: (e_valor!=null && e_valor!='') ? (e_valor) : ('0')})}
                                disabled={(estado && estado>=6)}
                                />
                        </Col>
                        <Col className="col-1 col px-0 p-relative">
                            <Button disabled={(estado && estado>=6)} onClick={(e) => { e.preventDefault(); this.AddEtapa(); }} className="p-absolute bottom-0"><i className={"fa fa-plus"}></i></Button>
                        </Col>
                        <Col className="col-2"/>
                    </Row>

                    <Row className="mt-1">
                        <Col className="col-12 my-2">
                            <Table className="table-sm t_etapas">
                                <thead>
                                    <tr>
                                        <th width={50}></th>
                                        <th className={'text-center'} width={100}>Etapa N°</th>
                                        <th className={'text-center'} width={150}>Valor</th>
                                        <th className={'text-center'} width={150}>Subtotal</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        e_array.map(
                                        (etapa, i) =>
                                            <tr
                                                key={i}
                                            >
                                            
                                        <td width={50}> {!(estado && estado>=6) && <Button className="btn-round btn-small btn-danger mr-1" onClick={(e) => { e.preventDefault(); this.removeEtapa(i) }}><i className="fa fa-times"></i></Button>}</td>
                                            <td className={'text-center'} width={100}>{i+1}</td>
                                            <td className={'text-right pr-3'} width={150}>{dateFunctions.formatCurrency(parseFloat(etapa.valor.replace(/[.]/g, '').replace(',', '.')))}</td>
                                            <td className={'text-right pr-3'} width={150}>{dateFunctions.formatCurrency(subTotal+=parseFloat(etapa.valor.replace(/[.]/g, '').replace(',', '.')))}</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        (e_array.length==0) && <tr><td colSpan="3" className={'text-center'}>No hay etapas cargadas</td></tr>
                                    }
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th></th>
                                        <th colSpan={2}>Total</th>
                                        <th className={'text-right'}>
                                            {dateFunctions.formatCurrency(e_array.reduce(redEtapas, 0))}
                                        </th>
                                    </tr>
                                </tfoot>
                            </Table>
                        </Col>
                    </Row>

                    <ParadigmaLabeledInput marginLeftAuto 
                        labelClassName="text-right" 
                        type={"number"}
                        label={"Precio"} 
                        style={{ fontWeight: 800 }} 
                        labelColumns={8} 
                        fieldColumns={4} 
                        inputComponent={
                            <CurrencyInput 
                                disabled={true}
                                placeholder={'0'}
                                className={'monto'}
                                selectOnFocus={true}
                                style={{ fontWeight: 800, textAlign: 'right' }} 
                                maskOptions={{includeThousandsSeparator: true, allowLeadingZeroes:true}}
                                value={precioFinal}
                                onChange={d => this.setState({precioFinal: d})}
                                onBlur={() => this.setState({precioFinal: (precioFinal!=null && precioFinal!='') ? (precioFinal) : ('0')})}
                                />
                        }/>

                    <Alert className={'my-2 text-center'} color="danger" isOpen={e_alert} toggle={()=>{this.setState({e_alert: !e_alert})}}>
                        {e_msj}
                    </Alert>

                </TabPane>

                {/*<TabPane tabId={4} className="py-0">
                    <Row className="mt-1">
                        <Col className="col-12">
                            <ParadigmaLabeledInput
                                labelColumns={12} 
                                fieldColumns={12} 
                                label={"Presupuesto Formal"}
                                inputComponent={
                                    <Fragment>
                                        {presupuestoFormalAux!=null &&
                                        <Col className={'col-12 mb-1'}>
                                            <Label onClick={()=>this.downloadPresupuestoFormal()} className={'xtDescarga'}>{'DESCARGAR'} {((presupuestoFormal!=null) ? (<i className="pl-4 txtDAdvertencia">{'(El archivo cargado será reemplazado.)'}</i>) : (''))}</Label>
                                        </Col>}
                                        
                                        <Col className={'col-12'}>
                                            <Input onChange={e => this.setState({ presupuestoFormal: e.target.files[0] })} type="file" disabled={false} />
                                        </Col>
                                    </Fragment>
                                }
                            />
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col className="col-12">
                            <Label>Facturas</Label>
                            <TableArchivos
                                action={'EDIT'}
                                archivos={documentosFacturas}
                                // onChange={documentosFacturas => this.onChangeField('documentosFacturas', documentosFacturas)}
                                onChange={data => this.setState({'documentosFacturas': data})}
                                url={api.proyectos.presupuesto.documento.replace('$id_proveedor', this.props.id())}
                            />
                        </Col>
                    </Row>
                </TabPane>*/}
                
                </TabContent>
                </div>

            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento3/Edit.js